/**
 * Custom accordion functionality for mobile product accordion
 */
document.addEventListener('DOMContentLoaded', function () {
  // Wait a bit to ensure the main JS has loaded
  setTimeout(function () {
    // Target all mobile accordion containers
    const mobileContainers = document.querySelectorAll('[data-mobile-accordion="container"]');

    // Iterate through each container
    mobileContainers.forEach(mobileContainer => {
      // Skip if the container has the 'print-only' class
      if (mobileContainer.classList.contains('print-only')) {
        console.log('Print-only accordion detected. Skipping.');
        return; // Continue to the next container
      }

      console.log('General mobile accordion found. Initializing.');

      const mobileItems = mobileContainer.querySelectorAll('[data-mobile-accordion="item"]');
      const mobileControls = mobileContainer.querySelectorAll('[data-mobile-accordion="control"]');

      // Set initial state of the first item
      const firstItem = mobileItems[0];
      if (firstItem) {
        firstItem.classList.add('is-active');
        const firstContent = firstItem.querySelector('.accordion__content');
        if (firstContent) {
          firstContent.style.maxHeight = firstContent.scrollHeight + 'px';
        }
        const firstControl = firstItem.querySelector('[data-mobile-accordion="control"]');
        if (firstControl) {
          firstControl.setAttribute('aria-expanded', 'true');
        }
      }

      // Add click handlers
      mobileControls.forEach(control => {
        control.addEventListener('click', function (e) {
          e.preventDefault();

          // Find parent item
          const item = this.closest('[data-mobile-accordion="item"]');
          const isActive = item.classList.contains('is-active');

          // Close other items
          mobileItems.forEach(otherItem => {
            if (otherItem !== item && otherItem.classList.contains('is-active')) {
              otherItem.classList.remove('is-active');
              const content = otherItem.querySelector('.accordion__content');
              content.style.maxHeight = null;
              otherItem.querySelector('[data-mobile-accordion="control"]').setAttribute('aria-expanded', 'false');
            }
          });

          // Toggle this item
          if (isActive) {
            item.classList.remove('is-active');
            const content = item.querySelector('.accordion__content');
            content.style.maxHeight = null;
            control.setAttribute('aria-expanded', 'false');
          } else {
            item.classList.add('is-active');
            const content = item.querySelector('.accordion__content');
            content.style.maxHeight = content.scrollHeight + 'px';
            control.setAttribute('aria-expanded', 'true');
          }
        });
      });
    });
  }, 500);
});